module.exports = __webpack_public_path__ + "images/edit-columns_1-13bb1790.svg";